import useSearchResults from "@/src/hooks/srp/useSearchResults"
import { selectAILastSearchedInput } from "@/src/redux/slices/aiRecommendationSlice"
import { useAppSelector } from "@/src/redux/store"
import { smartSRPMessages } from "@/src/utils/srp/aiRecommendation/locale"
import { Box, Tooltip } from "@mui/material"
import { useLocale } from "next-intl"
import { FC, useMemo } from "react"
import { ToggleSwitch } from "../../ui/toggleSwitch"

export const AutoApplyPreferencesToggle: FC<{
    onChange: (lastInput: string) => void
}> = ({ onChange }) => {
    const { selectedJourneyLeg } = useSearchResults()
    const lastInput = useAppSelector(state => selectAILastSearchedInput(state, 0))
    const locale = useLocale() as 'en' | 'ar'
    const smartSRPMessagesData = useMemo(() => smartSRPMessages[locale], [locale])

    if (selectedJourneyLeg === 1 || !lastInput) return null

    return (
        <Box>
            <Tooltip title={smartSRPMessagesData.autoApplyPreferencesToggle} >
                <ToggleSwitch onChange={(_, checked) => onChange(checked ? lastInput : '')} />
            </Tooltip>
        </Box>
    )
}
